export default "__VITE_ASSET__B6LQ8yrf__"